export const EDIT = 'user/EDIT'
export const LOGIN = 'user/LOGIN'
export const LOGOUT = 'user/LOGOUT'




// WEBPACK FOOTER //
// ./src/user/actionTypes.js